module.exports = __webpack_public_path__ + "static/scale-model-of-zimmerman-house-in-manchester-new-hampshire-6a2dddb95d54f9375acbfcbbfba25d61.png";